import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

const ToastDismissAllButton = () => {
	const activeToastIds = useRef(new Set());
	const [activeCount, setActiveCount] = useState(0);

	useEffect(() => {
		return toast.onChange(({ id, status }) => {
			if (status === 'added') {
				activeToastIds.current.add(id);
			} else if (status === 'removed') {
				activeToastIds.current.delete(id);
			}

			setActiveCount(activeToastIds.current.size);
		});
	}, []);

	if (activeCount === 0) {
		return null;
	}

	const handleDismissAll = () => {
		activeToastIds.current.clear();
		setActiveCount(0);
		toast.dismiss();
	};

	return (
		<Button
			variant="light"
			size="sm"
			className="toast-dismiss-all-btn shadow-sm"
			onClick={handleDismissAll}
			aria-label="Dismiss all notifications"
		>
			Dismiss all{activeCount > 1 ? ` (${activeCount})` : ''}
		</Button>
	);
};

export default ToastDismissAllButton;
